export const dynamicMenuItems = [
  'MRR-active-last-month',
  'MRR-active-current-month',
  'MRR-active-last-month-residential',
  'MRR-active-last-month-commercial',
  'MRR-active-current-month-residential',
  'MRR-active-current-month-commercial'
]
